import { render, staticRenderFns } from "./ScriptPage.vue?vue&type=template&id=623f6514"
import script from "./ScriptPage.vue?vue&type=script&lang=js"
export * from "./ScriptPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports